import { removeSpaces } from "../helper.js";
import { HelpBlock, FormGroup, Input, ControlLabel } from "ui-components";

type Props = {
  className?: string;
  placeholder?: string;
  label?: string;
  help?: string;
  value: string;
  handleChange: (e?: string) => void;
  error?: string;
  warning?: boolean;
  type: string;
  req?: boolean;
  noAutoComplete?: boolean;
  maxLength?: string;
  getVState?: (v: string) => void;
  dirty?: string;
};

const Text = ({
  className,
  label,
  warning,
  error,
  type = "text",
  placeholder,
  handleChange,
  help,
  value,
  req,
  noAutoComplete,
  getVState,
  dirty,
  maxLength,
}: Props) => (
  <FormGroup className={className} validationState={error}>
    {label && (
      <ControlLabel forId={removeSpaces(label)}>
        {label} {req && "*"}
      </ControlLabel>
    )}

    <Input
      type={type}
      placeholder={placeholder}
      onChange={handleChange}
      value={value}
      autoComplete={noAutoComplete ? "off" : undefined}
      maxLength={maxLength}
    />

    {help &&
      (Array.isArray(help) ? (
        help.map((h, i) => (
          <HelpBlock className={`${error === "warning" ? "warning" : ""}`} key={i}>
            {h}
          </HelpBlock>
        ))
      ) : (
        <HelpBlock className={`${error === "warning" ? "warning" : ""}`}>{help}</HelpBlock>
      ))}
  </FormGroup>
);

export default Text;
